import axios from 'axios';

import { LAST_LOCKED_MONTH } from '../endpoints';

export const getLastLockedMonth = () => axios.get(LAST_LOCKED_MONTH);
